import React from "react";
import { Placeholder, Row, Col } from "react-bootstrap";

function SkeletonForm({ fields = 4, columns = 1 }) {
  return (
    <Placeholder as="div" animation="glow">
      <Row>
        {Array(fields)
          .fill(null)
          .map((_, i) => (
            <Col md={12 / columns} key={i} className="mb-3">
              <Placeholder xs={3} size="sm" className="mb-2 d-block" />
              <Placeholder
                xs={12}
                size="lg"
                className="d-block rounded"
                style={{ height: "38px" }}
              />
            </Col>
          ))}
      </Row>
      <div className="mt-3">
        <Placeholder.Button variant="primary" xs={2} />
      </div>
    </Placeholder>
  );
}

export default SkeletonForm;
